import { convertToSnakeCase } from '../../helpers';
import { pageName } from '../constants';

export const creditFacility = {
  pageView: () => ({
    event_name: 'page_view, journey_start',
    page_name: 'vodapay: business advance: opf: cash flow facility',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website'
  }),

  toggleAccordian: (moduleName, accordianState) => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: cash flow facility',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_id: `vodapay: business advance: opf: click ${moduleName} accordian ${accordianState}`
  }),

  increaseCapitalLimit: () => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: cash flow facility',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_id: 'vodapay: business advance: opf: increase cash flow facility limit'
  }),

  inprogressIncreaseCapitalLimit: () => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: cash flow facility',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_id: 'vodapay: business advance: opf: already inprogress increase cash flow facility limit'
  }),

  viewWithdrawal: () => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: cash flow facility',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_id: 'vodapay: business advance: opf: view withdrawal'
  }),

  transactionsViewMore: () => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: cash flow facility',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_id: 'vodapay: business advance: opf: transactions view more'
  }),

  closeTransactionViewMoreModal: () => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: cash flow facility',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_id: 'vodapay: business advance: opf: transactions Detail: view more: close'
  }),

  transactionPageView: () => ({
    event_name: 'page_view',
    page_name: 'vodapay: business advance: opf: cash flow facility: transaction history',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website'
  })
};

export const submitSuccessModal = {
  pageView: () => ({
    event_name: 'page_view',
    page_name: 'vodapay: business advance: opf: cash flow facility: submit success modal',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website'
  }),
  submit: () => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: cash flow facility: submit success modal',
    page_url: window.location.href,
    page_section: 'business advance',
    page_channel: 'vodapay: business advance',
    page_subdomain: 'business advance',
    page_type: 'website',
    link_name: 'vodapay: business advance: opf: cash flow facility: submit success modal: Got it'
  })
};

export const creditFacilityWithdrawl = {
  pageView: () => ({
    event_name: 'page_view',
    page_name: 'vodapay: business advance: opf: cash flow facility: withdrawal review',
    page_url: window.location.href,
    page_section: 'business advance',
    page_channel: 'vodapay: business advance',
    page_subdomain: 'business advance',
    page_type: 'website'
  }),

  changeAmount: () => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: cash flow facility: withdrawal review',
    page_url: window.location.href,
    page_section: 'business advance',
    page_channel: 'vodapay: business advance',
    page_subdomain: 'business advance',
    page_type: 'website',
    link_name: 'vodapay: business advance: opf: cash flow facility: withdrawal review: cover amount'
  }),

  termsAndConditions: () => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: cash flow facility: withdrawal review',
    page_url: window.location.href,
    page_section: 'business advance',
    page_channel: 'vodapay: business advance',
    page_subdomain: 'business advance',
    page_type: 'website',
    link_name: 'vodapay: business advance: opf: cash flow facility: withdrawal review: terms and conditions'
  }),

  continue: () => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: cash flow facility: withdrawal review',
    page_url: window.location.href,
    page_section: 'business advance',
    page_channel: 'vodapay: business advance',
    page_subdomain: 'business advance',
    page_type: 'website',
    link_name: 'vodapay: business advance: opf: cash flow facility: withdrawal review: accept and continue'
  }),

  back: () => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: cash flow facility: withdrawal review',
    page_url: window.location.href,
    page_section: 'business advance',
    page_channel: 'vodapay: business advance',
    page_subdomain: 'business advance',
    page_type: 'website',
    link_name: 'vodapay: business advance: opf: cash flow facility: withdrawal review: back'
  })
};

export const limitIncrease = {
  pageView: () => ({
    event_name: 'page_view',
    page_name: 'vodapay: business advance: opf: cash flow facility: limit increase',
    page_url: window.location.href,
    page_section: 'business advance',
    page_channel: 'vodapay: business advance',
    page_subdomain: 'business advance',
    page_type: 'website'
  }),

  fieldInteraction: (urlPath, field, fieldValue, formName = null) => ({
    event_name: 'ui_interaction',
    page_name: `vodapay: business advance: opf: ${formName ? formName : pageName[urlPath] || 'untracked'}`,
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    [convertToSnakeCase(field)]: fieldValue
  }),

  back: () => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: cash flow facility: limit increase',
    page_url: window.location.href,
    page_section: 'business advance',
    page_channel: 'vodapay: business advance',
    page_subdomain: 'business advance',
    page_type: 'website',
    link_name: 'vodapay: business advance: opf: cash flow facility: limit increase: back'
  }),

  modalClose: (actionName) => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: cash flow facility: limit increase: success modal',
    page_url: window.location.href,
    page_section: 'business advance',
    page_channel: 'vodapay: business advance',
    page_subdomain: 'business advance',
    page_type: 'website',
    link_name: `vodapay: business advance: opf: cash flow facility: limit increase: success modal: ${actionName ? actionName : 'close'}`
  }),

  submit: (amount) => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: cash flow facility: limit increase',
    page_url: window.location.href,
    page_section: 'business advance',
    page_channel: 'vodapay: business advance',
    page_subdomain: 'business advance',
    page_type: 'website',
    link_name: 'vodapay: business advance: opf: cash flow facility: limit increase: submit',
    cover_amount: amount
  }),
  formStart: () => ({
    event_name: 'form_start',
    page_name: 'vodapay: business advance: opf:  cash flow facility: limit increase',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    form_name: 'business advance: opf:  cash flow facility: limit increase'
  }),
  formEnd: (clickButton, amount = null) => ({
    event_name: 'ui_interaction, form_end',
    page_name: 'vodapay: business advance: opf:  cash flow facility: limit increase',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    form_name: 'business advance: opf: apply cash flow facility: limit increase',
    link_id: `vodapay: business advance: opf: cash flow facility: limit increase: ${clickButton}`,
    cover_amount: amount
  })
};

export const limitIncreaseSuccess = {
  pageView: () => ({
    event_name: 'page_view, journey_end',
    page_name: 'vodapay: business advance: opf: cash flow facility: limit increase: submitted',
    page_url: window.location.href,
    page_section: 'business advance',
    page_channel: 'vodapay: business advance',
    page_subdomain: 'business advance',
    page_type: 'website',
    journey_name: 'business advance: opf: cash flow facility'
  }),

  link: () => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: cash flow facility: limit increase: submitted',
    page_url: window.location.href,
    page_section: 'business advance',
    page_channel: 'vodapay: business advance',
    page_subdomain: 'business advance',
    page_type: 'website',
    link_name: 'vodapay: business advance: opf: cash flow facility: limit increase: submitted: [link text]'
  })
};
